import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { hasPermission } from '@features/rbac/permissions'

export const Route = createFileRoute('/_layout/tools/teams-administration')({
  beforeLoad: () => {
    if (!hasPermission('teams.manage')) throw redirect({ to: '/unauthorised' })
  },
  component: RouteComponent,
  staticData: {
    crumb: {
        label: "Teams Administration",
    }
  }
})

function RouteComponent() {
  return <Outlet/>
}
